import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
  // Setting `pure` to true (default) means the pipe only re-runs if its input changes.
  // Setting it to false would make it re-run on every change detection cycle,
  // which is rarely needed for simple string transformations and can impact performance.
  pure: true,
})
export class CapitalizePipe implements PipeTransform {
  /**
   * Transforms a string by capitalizing its first letter.
   *
   * @param value The input string to capitalize.
   * @returns The capitalized string, or an empty string if the input is null, undefined, or empty.
   */
  transform(value: string | null | undefined): string {
    if (value === null || value === undefined || value.length === 0) {
      return ''; // Return an empty string for null, undefined, or empty inputs
    }

    // Ensure the value is treated as a string
    const stringValue = String(value);

    // Capitalize the first character and concatenate with the rest of the string
    return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
  }
}
